import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import LanguageIcon from "@mui/icons-material/Language";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Box from "@mui/material/Box";
import { useLanguage } from "../hooks/useLanguage.jsx";
import colors from "../theme/colors.jsx";


export function Multilanguage() {
  const { i18n } = useTranslation();
  const { switchLanguage } = useLanguage();

  const userSettings = [
    { key: "es", value: "Castellano" },
    { key: "en", value: "English" },
    { key: "ca", value: "Català" },
    { key: "ga", value: "Galego" },
    { key: "eu", value: "Euskera" },
    { key: "va", value: "Valencià" },
  ];
  const [languajeSelected, setLanguajeSelected] = useState(() => {
    let s = userSettings[0];
    if (i18n.language != null) {
      s = userSettings.find((l) => l.key === i18n.language);
      if (s == null) s = userSettings[0];
    }
    return s;
  });

  const changeLanguage = (language) => {
    setLanguajeSelected(language);
    setOpen(false);

    switchLanguage(language.key);
  };

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Stack direction="row" spacing={2}>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          color="text"
        >
          <Stack direction="row" spacing={1} alignItems={"center"}>
            <LanguageIcon sx={{color: colors.primary}} />
            <Typography variant="parrafoPrimary" lineHeight="1">{languajeSelected.value}</Typography>
          </Stack>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {(
            { TransitionProps, placement } // Esto sirve para que el menú salga hacía bajo desde el botón
          ) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                  >
                    {userSettings.map((setting) => (
                      <MenuItem
                        key={setting.key}
                        onClick={() => {
                          changeLanguage(setting);
                        }}
                      >
                        <Typography key={setting.key} color="primary">
                          {setting.value}
                        </Typography>
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Stack>
    </>
  );
}
